<form [formGroup]="specEigenWoningFormGroup">
        <div formGroupName="specificatieEW">
            <div formGroupName="opbouw">
                    <div class="row">
                        <div class="col-7">
                            Eigenwoningforfait
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="eigenWoningForfait"
                                    id="eigenWoningForfait"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>

                <div *ngIf="specEigenWoning.specificatieEW?.opbouw?.huurinkomstenEW !== undefined">
                    <div class="row">
                        <div class="col-7">
                            Belaste huurinkomsten eigen woning (70%)
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="huurinkomstenEW"
                                    id="huurinkomstenEW"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specEigenWoning.specificatieEW?.opbouw?.eigenWoningRente?.valueOf() !== 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Rente eigenwoningschulden
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="eigenWoningRente"
                                    id="eigenWoningRente"
                                    class="custom-input-150"
                                    align="right"
                                    [decimals]="0"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specEigenWoning.specificatieEW?.opbouw?.kostenEigenWoningSchuld !== undefined &&
                                              specEigenWoning.specificatieEW?.opbouw?.kostenEigenWoningSchuld!.valueOf() > 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Kosten financiering eigen woningschuld
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="kostenEigenWoningSchuld"
                                    id="kostenEigenWoningSchuld"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specEigenWoning.specificatieEW?.opbouw?.renteRestschuldEigenWoning !== undefined">
                    <div class="row">
                        <div class="col-7">
                            Af: Rente inzake restschulden
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="renteRestschuldEigenWoning"
                                    id="renteRestschuldEigenWoning"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div  *ngIf="specEigenWoning.specificatieEW?.opbouw?.belastDeelKapitaalverzekering !== undefined">
                    <div class="row">
                        <div class="col-7">
                            Belast deel kapitaalverzekering
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="belastDeelKapitaalverzekering"
                                    id="belastDeelKapitaalverzekering"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div  *ngIf="specEigenWoning.specificatieEW?.opbouw?.erfpachtcanon !== undefined">
                    <div class="row">
                        <div class="col-7">
                            Af: Betaalde erfpachtcanon
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    formControlName="erfpachtcanon"
                                    id="erfpachtcanon"
                                    class="custom-input-150"
                                    [decimals]="0"
                                    align="right"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
            </div>
        </div>
</form>

<form [formGroup]="berekeningBox1FormGroup">
    <div formGroupName="box1">
        <div formGroupName="opbouwInkomen">
                <div class="row">
                    <div class="col-7">
                        <p><b>Inkomsten eigen woning</b></p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                formControlName="saldoEigenWoning"
                                id="saldoEigenWoning"
                                class="custom-input-150"
                                align="right"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </div>
</form>

<div class="space20"></div>

<form [formGroup]="geenOfGeringeEWSFg">
    <div *ngIf="berekening.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld !== undefined &&
                                    berekening.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld!.valueOf() > 0">
        <div class="row">
            <div class="col-7">
                <p><b>Aftrek geen of kleine woningschuld</b></p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
                <snelstart-ui-number-form-control
                        formControlName="totaalGOGEWS"
                        id="totaalGOGEWS"
                        class="custom-input-150"
                        align="right"
                        prefix=" €"
                        [decimals]="0"
                ></snelstart-ui-number-form-control>
            </div>

        </div>
    </div>
</form>

